import { STATE } from '../constants/stateClasses';

/**
 * @param {HTMLElement} HTMLElement Element which class will be toggled.
 * @param {Object} [options]
 * @param {string} [options.className] Element's class name to toggle. If className is not given, the STATE.active class is toggled.
 * @param {boolean | undefined} [options.force] If force is not given, "toggles" token, removing it if it's present and adding it if it's not present. If force is true, adds token (same as add()). If force is false, removes token (same as remove()).
 */
const toggleClass = (
  HTMLElement,
  { className = STATE.active, force = undefined } = {}
) => {
  HTMLElement?.classList.toggle(className, force);
};

export default toggleClass;
